module.exports = __webpack_public_path__ + "static/media/abstract3.3c346536.jpg";